<template>
  <div class="EmployeeCard mb-24 text-left">
    <div class="pt-16 type-base flex flex-col gap-12 desk:gap-16">
      <div v-if="blok.image && blok.image.filename" class="aspect-portrait relative">
        <nuxt-img
          v-if="blok.image && blok.image.filename"
          preset="standard"
          loading="lazy"
          sizes="sm:100vw desk:1260px"
          class="absolute top-0 left-0 w-full h-full object-cover"
          :class="blok.focalPoint"
          :src="blok.image.filename"
          :alt="blok.image.alt || ''"
        />
      </div>
      <div class="flex flex-col gap-6 desk:gap-8">
        <div class="type-headline-md">{{ blok.name }}</div>
        <div class="flex flex-col gap-2 desk:gap-4">
          <div>{{ blok.title }}</div>
          <div class="text-text-subtle">{{ blok.location }}</div>
          <div class="text-text-subtle">{{ blok.area }}</div>
        </div>
      </div>
      <div class="flex flex-col gap-8">
        <div
          v-if="blok.mail.trim() !== ''"
          class="btn btn--text mobOnly:text-12"
        >
          <a
            :href="`mailto:${blok.mail}`"
            class="inline-flex items-center gap-8 opacity-60 hover:opacity-100 transition duration-300 ease-in-out"
          >
            <img
              src="/icons/mail.svg"
              :alt="$t('employeeCard.mailAlt')"
              class="w-24 h-24"
            >
            <span class="hidden desk:inline-block">{{ blok.mail }}</span>
          </a>
        </div>
        <div
          v-if="blok.phone.trim() !== ''"
          class="btn btn--text mobOnly:text-12"
        >
          <a :href="`tel:${blok.phone}`" class="inline-flex items-center gap-8 opacity-60 hover:opacity-100 transition duration-300 ease-in-out">
            <img
              src="/icons/phone.svg"
              :alt="$t('employeeCard.phoneAlt')"
              class="w-24 h-24"
            >
            <span class="hidden desk:inline-block">{{ blok.phone }}</span>
          </a>
        </div>
      </div>

      <div v-if="$sbRichTextHasContent(blok.presentation)" class="wysiwyg pb-16">
        <Transition name="reveal">
          <div v-if="expanded" class="pb-12">
            <ExtendedWysiwyg :content="blok.presentation" />
          </div>
        </Transition>
        <button
          class="type-headline-base text-text-attention flex items-center gap-4 select-none"
          type="button"
          @click="expanded = !expanded"
        >
          <span class="underline">
            {{ expanded ? $t('productPage.truncateTextCtaOpen') : $t('productPage.truncateTextCtaClosed') }}
          </span>
          <img
            src="/icons/chevron-down.svg"
            class="w-16 transition-all"
            alt=""
            :class="{
              'rotate-180': expanded
            }"
          >
        </button>
      </div>

    </div>
  </div>
</template>

<script setup lang="ts">
import type { EmployeeCardProps } from '#constants/types/storyblok';

defineProps<{
  blok: EmployeeCardProps,
}>();

const expanded = ref(false);
</script>
